import React from 'react';
import HotelInfo from '../../components/HotelInfo';
import HotelInfoMobile from '../../components/HotelInfo/HotelInfoMobile';

interface HotelInfoContainerProps {
  isLastReview: boolean;
  hasRating: boolean;
  hasFacts: boolean;
  hasExtraItems: boolean;
  hasAboutHotel: boolean;
  isHotelOnly: boolean;
  isMobile: boolean;
  isExpertReviewExists: boolean;
}
export const HotelInfoContainer = ({
  isMobile,
  ...props
}: HotelInfoContainerProps) =>
  isMobile ? <HotelInfoMobile {...props} /> : <HotelInfo {...props} />;
